module.exports = __webpack_public_path__ + "fonts/roboto-v20-latin-500italic.288ad9c.woff";